export const educatorHeader = 'Educator Practice'
export const educatorTooltipLabel = 'Educator label'
export const schoolwideHeader = 'Schoolwide Practice'
export const schoolwideTooltipLabel = 'Schoolwide label'
export const studentTooltipLabel = 'Student label'
